export const NA = "-"
